<template>
  <v-row justify="center" class="pa-0 ma-0">
    <v-btn
        class="text-none"
        depressed
        height="44"
        color="secondary"
        block
        @click.stop="$emit('load-students'), enabled = true"
        v-if="$checkPermission('retrieving_data_from_enrollment')"
    >
      <v-icon class="mr-2">mdi-transfer</v-icon> Dohvati iz eUpis-a
    </v-btn>
  <v-dialog v-model="enabled" width="500" @click:outside="enabled = false">
    <v-card>
      <v-card-title primary-title> Jeste li sigurni? </v-card-title>

      <v-card-text style="padding-top: 20px">
        Dohvat učenika iz eUpis-a<br /><br />
        <div>
          <v-form>
            <v-row v-for="(item, index) in loadedStudents" :key="index">
              <v-col cols="4">
                <v-subheader class="justify-end">Učenik/ca: </v-subheader>
              </v-col>
              <v-col v-if="item.id" cols="6">
                <v-autocomplete
                    :items="loadedStudents"
                    item-value="id"
                    item-text="full_name"
                    v-model="item.id"
                    height="44"
                    dense
                    hide-details
                    outlined
                    single-line
                    hide-no-data
                    disabled
                >
                  <template slot="item" slot-scope="{item}">
                    {{item.full_name}} - {{item.aai_email ? item.aai_email : ''}}
                  </template>
                  <template slot="selection" slot-scope="{item}">
                    {{item.full_name}} - {{item.aai_email ? item.aai_email : ''}}
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col v-else cols="6">
                <v-autocomplete
                    :items="loadedStudents"
                    placeholder="Odaberite učenika"
                    item-value="id"
                    item-text="full_name"
                    v-model="item.id"
                    height="44"
                    dense
                    hide-details
                    outlined
                    single-line
                    hide-no-data
                >
                  <template slot="item" slot-scope="{item}">
                    {{item.full_name}} - {{item.aai_email}}
                  </template>
                  <template slot="selection" slot-scope="{item}">
                    {{item.full_name}} - {{item.aai_email}}
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col class="d-flex justify-end">
                <v-checkbox
                    height="44"
                    style="min-width: 44px; width: 44px"
                    :value="item.id"
                    v-model="selectedStudents"
                >
                  <v-icon size="20" color="white">mdi-close</v-icon>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            @click="enabled = false"
            class="text-none"
            depressed
            large
            outlined
        >Odustani</v-btn
        >
        <v-btn
            color="error"
            class="text-none"
            @click="transferStudents()"
            depressed
            large
        >Upiši učenike</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "DepartmentStudentsGetEnrollmentsDialog",
  props: {
    loadedStudents: {
      type: Array,
      required: true,
      default: ()=>[]
    },
    enrolledStudents: {
      type: Array,
      required: true,
      default: ()=>[]
    }
  },
  data(){
    return {
      enabled: false,
      selectedStudents: []
    }
  },
  methods:{
    transferStudents() {
      this.$emit("save-students", this.selectedStudents);
      this.enabled = false;
    },
  },
  watch:{
    enabled: {
      handler() {
        if(this.enabled && this.enrolledStudents.length>0){
          this.enrolledStudents.forEach(student=>this.selectedStudents.push(student.id))
        }
      },
    },
  }
}
</script>

<style scoped>

</style>